import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import useDashboardContext from 'contexts/dashboard.context';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down.svg';

const CokitchenDropdown = () => {
  const { cokitchens, activeCokitchen, setActiveCokitchen } = useDashboardContext();
  const [show, setShow] = useState(false);

  return (
    <Dropdown
      placement='bottom'
      visible={show}
      onClickOutside={() => setShow(false)}
      content={
        <div
          onClick={() => setShow(!show)}
          className='cursor-pointer flex items-center rounded-[40px] py-[9px] px-[18px] gap-1 bg-gray-14 hover:bg-red-1 transition-all'>
          <div className='max-w-[100px] whitespace-nowrap truncate'>{activeCokitchen?.name}</div>
          <ArrowDownIcon className='text-gray-8' />
        </div>
      }>
      <DropdownList>
        {cokitchens?.map((kitchen) => (
          <DropdownItem
            key={kitchen.id}
            onClick={() => {
              setActiveCokitchen(kitchen);
              setShow(false);
            }}>
            <p className='text-gray-6 font-medium text-sm'>{kitchen.name}</p>
          </DropdownItem>
        ))}
      </DropdownList>
    </Dropdown>
  );
};

export default CokitchenDropdown;
